/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import type { TasteArtist } from '@/tastes/tastesService'
import type { Maybe } from '@amazon/vinyl-util'

/** The ids of a `preselectedArtistIds` param: a single id or a comma-separated list. */
export function parsePreselectedArtistIds(param: Maybe<string>): readonly string[] {
    return (
        param
            ?.split(',')
            .map((id) => id.trim())
            .filter(Boolean) ?? []
    )
}

/** Pins the preselected artists to the front of the popular tab; other tabs keep their order. */
export function pinPreselectedArtists(
    topArtists: readonly TasteArtist[],
    preselected: readonly TasteArtist[],
    isPopularTab: boolean
): readonly TasteArtist[] {
    if (!isPopularTab || preselected.length === 0) return topArtists
    const pinnedIds = new Set(preselected.map((artist) => artist.id))
    return [...preselected, ...topArtists.filter((artist) => !pinnedIds.has(artist.id))]
}
